import { render } from "./BaseNavBar.vue?vue&type=template&id=4cdb3dd0&scoped=true&ts=true"
import script from "./BaseNavBar.vue?vue&type=script&lang=ts"
export * from "./BaseNavBar.vue?vue&type=script&lang=ts"

import "./BaseNavBar.vue?vue&type=style&index=0&id=4cdb3dd0&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cdb3dd0"]])

export default __exports__